// src/utils/receipt.js — v4
// CHANGED FROM v3 (19 Jul 2026): removed the dormant GST_ENABLED
// branch entirely, per Amit's explicit "no chances at all" call on
// InsideOUT separation — that branch's string ("a subsidiary of
// InsideOUT · GSTIN ...") never rendered live (GST_ENABLED was always
// false), but sat as a landmine that would have gone live with an
// InsideOUT + GST reference the moment GST work resumed and someone
// flipped that flag. Footer line now always reads plain "nobrand
// store" — no GST number, no InsideOUT reference, no toggle to
// accidentally re-enable this later. GST_ENABLED/GST_NUMBER constants
// removed since nothing references them anymore.
// CHANGED FROM v2 (18 Jul 2026): GST per-order invoice feature
// reverted per Amit's call — parked for a future session. Back to v1
// behavior exactly (global GST_ENABLED constant, currently false, no
// per-order choice).
const WALLET_VARIANTS = [
  'Cashback lands in your nb wallet automatically',
  'Every order adds a little extra to your nb wallet',
  'Shop more, earn more — cashback keeps stacking up',
];
const RETURN_VARIANTS = [
  'Wrong size or damaged? Free pickup, no questions',
  'Return pickup is free — we cover the cost, not you',
  'Received the wrong item? We will arrange a free pickup',
];
const RESELLER_LINE_FIXED = 'Resell our products, keep the profit — zero cost to start';
function pickRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}
export async function generateReceiptImage({ orderId, dateStr, total, cart }) {
  await (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve());
  const width = 600;
  const items = Array.isArray(cart) ? cart : [];
  const itemsBlockHeight = items.length > 0 ? (44 + items.length * 46 + 20) : 0;
  const height = 900 + itemsBlockHeight;
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#F4F2EE';
  ctx.fillRect(0, 0, width, height);
  const headerHeight = 150;
  ctx.fillStyle = '#1B2A4A';
  ctx.fillRect(0, 0, width, headerHeight);
  ctx.fillStyle = '#F4F2EE';
  ctx.textAlign = 'center';
  ctx.font = '600 38px "Cormorant Garamond", serif';
  ctx.fillText('nobrand store', width / 2, 68);
  ctx.fillStyle = '#D4A020';
  ctx.font = 'italic 14px "DM Sans", sans-serif';
  ctx.fillText('dressed. not branded.', width / 2, 94);
  ctx.fillStyle = '#D4A020';
  ctx.fillRect(width / 2 - 30, 110, 60, 2);
  ctx.fillStyle = 'rgba(244,242,238,0.7)';
  ctx.font = '500 11px "DM Sans", sans-serif';
  ctx.fillText('RECEIPT', width / 2, 134);
  let y = 195;
  ctx.textAlign = 'center';
  ctx.fillStyle = '#111827';
  ctx.font = '600 15px "DM Sans", sans-serif';
  ctx.fillText('Thanks for shopping with us', width / 2, y);
  ctx.fillStyle = '#6B7280';
  ctx.font = '400 12px "DM Sans", sans-serif';
  ctx.fillText('Here is a quick summary of your order', width / 2, y + 20);
  y += 60;
  const cardHeight = 130;
  ctx.fillStyle = '#FFFFFF';
  ctx.fillRect(56, y, width - 112, cardHeight);
  ctx.strokeStyle = 'rgba(27,42,74,0.1)';
  ctx.lineWidth = 1;
  ctx.strokeRect(56, y, width - 112, cardHeight);
  const rows = [
    ['Order #', orderId],
    ['Date', dateStr],
    ['Amount paid', `Rs. ${Number(total).toLocaleString('en-IN')}`],
  ];
  let ry = y + 32;
  rows.forEach(([label, value], i) => {
    ctx.textAlign = 'left';
    ctx.fillStyle = '#6B7280';
    ctx.font = '400 13px "DM Sans", sans-serif';
    ctx.fillText(label, 76, ry);
    ctx.textAlign = 'right';
    ctx.fillStyle = i === 2 ? '#1B2A4A' : '#111827';
    ctx.font = (i === 2 ? '600 16px' : '500 14px') + ' "DM Sans", sans-serif';
    let displayValue = String(value);
    if (ctx.measureText(displayValue).width > width - 250) {
      while (ctx.measureText(displayValue + '…').width > width - 250 && displayValue.length > 0) {
        displayValue = displayValue.slice(0, -1);
      }
      displayValue += '…';
    }
    ctx.fillText(displayValue, width - 76, ry);
    ry += 40;
  });
  y += cardHeight + 30;
  if (items.length > 0) {
    ctx.textAlign = 'left';
    ctx.fillStyle = '#111827';
    ctx.font = '600 13px "DM Sans", sans-serif';
    ctx.fillText('Order details', 56, y);
    y += 20;
    items.forEach((item) => {
      const rowHeight = 46;
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(56, y, width - 112, rowHeight - 4);
      ctx.strokeStyle = 'rgba(27,42,74,0.08)';
      ctx.lineWidth = 1;
      ctx.strokeRect(56, y, width - 112, rowHeight - 4);
      const lineTotal = (Number(item.price) || 0) * (Number(item.qty) || 1);
      let nameLine = String(item.id || '');
      if (item.colorCode) nameLine += ` · ${item.colorCode}`;
      if (item.size) nameLine += ` · ${item.size}`;
      ctx.textAlign = 'left';
      ctx.fillStyle = '#1B2A4A';
      ctx.font = '500 12px "DM Sans", sans-serif';
      let displayName = nameLine;
      while (ctx.measureText(displayName).width > 300 && displayName.length > 0) {
        displayName = displayName.slice(0, -1);
      }
      ctx.fillText(displayName, 72, y + 18);
      ctx.fillStyle = '#6B7280';
      ctx.font = '400 11px "DM Sans", sans-serif';
      ctx.fillText(`Qty ${item.qty || 1} × Rs. ${Number(item.price || 0).toLocaleString('en-IN')}`, 72, y + 34);
      ctx.textAlign = 'right';
      ctx.fillStyle = '#111827';
      ctx.font = '600 13px "DM Sans", sans-serif';
      ctx.fillText(`Rs. ${lineTotal.toLocaleString('en-IN')}`, width - 72, y + 26);
      y += rowHeight;
    });
    y += 16;
  }
  ctx.textAlign = 'center';
  ctx.fillStyle = '#1B2A4A';
  ctx.font = '400 12px "DM Sans", sans-serif';
  ctx.fillText('Dispatch in 2-3 days · delivery in 5-7 business days', width / 2, y);
  y += 45;
  ctx.strokeStyle = 'rgba(27,42,74,0.12)';
  ctx.beginPath();
  ctx.moveTo(56, y);
  ctx.lineTo(width - 56, y);
  ctx.stroke();
  y += 34;
  ctx.fillStyle = '#D4A020';
  ctx.font = '600 11px "DM Sans", sans-serif';
  ctx.fillText('WHILE YOU ARE HERE', width / 2, y);
  y += 30;
  const perks = [pickRandom(WALLET_VARIANTS), pickRandom(RETURN_VARIANTS), RESELLER_LINE_FIXED];
  perks.forEach((text) => {
    ctx.textAlign = 'center';
    ctx.fillStyle = '#4B5563';
    ctx.font = '400 12px "DM Sans", sans-serif';
    ctx.fillText(text, width / 2, y);
    y += 26;
  });
  y += 20;
  ctx.strokeStyle = 'rgba(27,42,74,0.12)';
  ctx.beginPath();
  ctx.moveTo(56, y);
  ctx.lineTo(width - 56, y);
  ctx.stroke();
  y += 32;
  ctx.fillStyle = '#6B7280';
  ctx.font = '400 11px "DM Sans", sans-serif';
  ctx.fillText('Questions about this order? Message us anytime', width / 2, y);
  y += 28;
  ctx.fillStyle = '#2F6FED';
  ctx.font = '600 14px "DM Sans", sans-serif';
  ctx.fillText('+91 93630 12496   ·   nobrandstore.co.in', width / 2, y);
  y += 26;
  ctx.fillStyle = '#9CA3AF';
  ctx.font = '400 10px "DM Sans", sans-serif';
  ctx.fillText('nobrand store', width / 2, y);
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), 'image/png');
  });
}
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}